import { render } from "./DrawingsMail.vue?vue&type=template&id=7d464466"
import script from "./DrawingsMail.vue?vue&type=script&lang=js"
export * from "./DrawingsMail.vue?vue&type=script&lang=js"

import "./DrawingsMail.vue?vue&type=style&index=0&id=7d464466&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__